import { createSelector, weakMapMemoize } from 'reselect'
import { ANYWHERE_PLACE_ID } from 'constants/search'

const selectStreamingData = (state: App.State, typeaheadId: string) =>
  state.search.typeaheadStreamingData[typeaheadId]

const selectPlaces = (state: App.State) => state.destination.places

// Mirrors `getDisplayPlaceId`'s guards (property / ANYWHERE / missing placeIds) but operates
// on the mapped `ExtractedSearchParamsV2` shape stored in Redux, where `placeIds` is flat.
function getEnrichablePlaceId(extracted: App.SearchItemV3['searchItem']['extractedData']): string | undefined {
  if (!extracted || 'property' in extracted) return undefined
  if (!('placeIds' in extracted)) return undefined
  const first = extracted.placeIds?.[0]
  if (!first || first === ANYWHERE_PLACE_ID) return undefined
  return first
}

export const selectEnrichedTypeaheadStreamingData = createSelector(
  [selectStreamingData, selectPlaces],
  (streamingData, places) => {
    if (!streamingData?.results?.data) return streamingData

    const enriched = streamingData.results.data.map((item) => {
      const placeId = getEnrichablePlaceId(item.searchItem?.extractedData)
      const place = placeId ? places[placeId] : undefined
      if (!place) return item
      const secondaryText = place.location ?? item.format.secondaryText
      return {
        ...item,
        value: place.name,
        format: { ...item.format, mainText: place.name, secondaryText },
        display: { ...item.display, mainText: place.name, secondaryText },
      }
    })

    return {
      ...streamingData,
      results: { ...streamingData.results, data: enriched },
    }
  },
  { memoize: weakMapMemoize, argsMemoize: weakMapMemoize },
)
